import React from 'react';

const activeIngredients = [
  {
    name: "L-Citrulline-DL-Malate 2:1",
    norwegianDose: "3,000mg",
    americanDose: "15,000mg",
    subItems: [
      { name: "L-Citrulline", norwegianDose: "2,000mg", americanDose: "10,000mg" },
      { name: "Malic Acid", norwegianDose: "1,000mg", americanDose: "5,000mg" }
    ]
  },
  {
    name: "Beta-Alanine",
    norwegianDose: "1,280mg",
    americanDose: "6,400mg"
  },
  {
    name: "Creatine MonoHydrate",
    norwegianDose: "1,000mg",
    americanDose: "5,000mg"
  },
  {
    name: "Betaine (Trimethylglycine)",
    norwegianDose: "500mg",
    americanDose: "2,500mg"
  },
  {
    name: "Taurine",
    norwegianDose: "400mg",
    americanDose: "2,000mg"
  },
  {
    name: "L-Tyrosine",
    norwegianDose: "300mg",
    americanDose: "1,500mg"
  },
  {
    name: "Caffeine Anhydrous",
    norwegianDose: "70mg",
    americanDose: "350mg"
  },
  {
    name: "Lion's Mane Extract (Hericium erinaceus)",
    norwegianDose: "40mg",
    americanDose: "200mg"
  },
  {
    name: "Black Pepper Extract 95% Piperine",
    norwegianDose: "2mg",
    americanDose: "10mg"
  }
];

const IngredientsOverviewMaxed = () => {
  return (
    <div className="bg-card p-6 rounded-lg border border-border">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-xl font-bold text-primary">Innholdsliste</h3>
        <span className="text-sm text-muted-foreground">Per servering</span>
      </div>
      
      <div className="mb-4 p-3 bg-primary/10 rounded-lg border border-border">
        <p className="text-primary font-semibold text-sm">
          Norsk servering: 1 skje | Amerikansk servering: 5 skjeer
        </p>
        <p className="text-primary/70 text-xs mt-1">
          Totalt 100 norske serveringer / 20 amerikanske serveringer per boks
        </p>
      </div>

      <div className="space-y-1">
        <div className="grid grid-cols-3 gap-2 text-xs font-semibold text-primary border-b border-border pb-2">
          <span>Ingrediens</span>
          <span className="text-center">1 skje (NO)</span>
          <span className="text-center">5 skjeer (US)</span>
        </div>

        {activeIngredients.map((ingredient, index) => (
          <React.Fragment key={index}>
            <div className="grid grid-cols-3 gap-2 text-sm py-2 border-b border-border/20">
              <span className="text-foreground font-medium">{ingredient.name}</span>
              <span className="text-center text-muted-foreground">{ingredient.norwegianDose}</span>
              <span className="text-center font-semibold text-primary">{ingredient.americanDose}</span>
            </div>
            {ingredient.subItems?.map((subItem, subIndex) => (
              <div key={subIndex} className="grid grid-cols-3 gap-2 text-xs py-1 pl-4 text-muted-foreground border-b border-border/10">
                <span>↳ {subItem.name}</span>
                <span className="text-center">{subItem.norwegianDose}</span>
                <span className="text-center">{subItem.americanDose}</span>
              </div>
            ))}
          </React.Fragment>
        ))}
      </div>

      <div className="mt-4 space-y-2">
        <h4 className="text-sm font-semibold text-foreground">Andre ingredienser:</h4>
        <p className="text-xs text-muted-foreground">
          Naturlig smak, sitronsyre, sukralose, acesulfam-K, silisiumdioksid
        </p>
      </div>

      <div className="mt-4 p-3 bg-primary/10 rounded-lg border border-border">
        <p className="text-primary text-xs">
          Alle ingredienser er dosert basert på kliniske studier.
        </p>
      </div>
    </div>
  );
};

export default IngredientsOverviewMaxed;
